import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportTimeChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.trips.hours",
		title: "Hours Driven",
		yAxisLabel: "Duration (Hours)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.trips.hours,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.trips.hours );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
